import React from 'react';
export default function Image(props) {
    const { src, srcSet } = props;
    // const webpConverter = LTG_VARIABLES?.media?.webpConverter;
    // const webpConverterEnabled = webpConverter?.enabled || false;
    // if(webpConverterEnabled && webpConverter?.settings?.type === 'passthru'){
    // 	src = '/wp-content/webpc-passthru.php?src=' + src;
    // }
    return React.createElement("picture", null,
        React.createElement("source", { srcSet: srcSet || src }),
        React.createElement("img", { width: (props === null || props === void 0 ? void 0 : props.width) || 100, height: (props === null || props === void 0 ? void 0 : props.height) || 100, src: props.src, className: props.className, alt: props.alt }));
}
